import { Box } from '@mui/material';
import React from 'react';

interface D3DImageViewProps {
  images: string[];
}
const D3DImageView = (props: D3DImageViewProps) => {
  const { images } = props;

  let loadCount = 0;
  let preIndex = 0;
  let x1 = 0;
  let y1 =0;
  let dis = 0;
  let preX =0;
  let btouch = false;

  const onDragMove = (index) => {
    for (let i=0; i<images.length; i++) {
      const pre = document.getElementById(i+'');
      pre.style.visibility='hidden';
    }
    const show = document.getElementById(index%images.length+'');
    show.style.visibility='visible';
  };

  if (images.length==0) {
    return null;
  }

  const onMouseDown = (ev) => {
    btouch = true;
    x1 = ev.clientX ?? ev.targetTouches[0].clientX;
    y1 = ev.clientY ?? ev.targetTouches[0].clientY;
    dis = 0;
    preX =0;
  };

  const onMouseMove =(ev) => {
    if (!btouch) {
      return;
    }
    if (ev.clientX==preX) {
      return;
    }

    if ((ev.clientX??ev.targetTouches[0].clientX)>preX) {
      let inde = ++preIndex;
      let real = 0;
      if (inde<0) {
        real  = images.length+preIndex%images.length;
      } else {
        real = inde;
      }
      onDragMove(real);
    } else {
      let inde = --preIndex;
      let real = 0;
      if (inde<0) {
        real  = images.length+preIndex%images.length
      } else {
        real = inde;
      }
      onDragMove(real);
    }
    preX = ev.clientX??ev.targetTouches[0].clientX;
  };

  const onMouseLeave= () => {
    btouch = false;
  };

  return <Box onTouchMove={onMouseMove}
    onTouchStart={(ev) => {
      onMouseDown(ev);
    }}
    onTouchCancel={onMouseLeave}
    onMouseLeave={onMouseLeave}
    onMouseUp={onMouseLeave}
    onMouseMove={onMouseMove}
    onMouseDown={(ev) => {
      onMouseDown(ev);
    }}
    style={{
      position:'relative',
      display:'flex',
      justifyContent:'center',
      alignItems:'center',
      width:'100%',
      height:'100%'
    }}
  >
    {images.map((item, i) => {
      return <img id={`d3d_${i}`} src={item} key={`d3d_${i}`} draggable={false}
        style={{
          width:'100%', height:'100%',
          visibility : preIndex==i ? 'visible' : 'hidden',
          WebkitUserSelect:'none',
          position:'absolute',
          left: 0, top: 0,
          right: 0, bottom: 0,
          objectFit: 'contain'
        }}
        onLoad={() => {
          loadCount = loadCount+1;
          document.getElementById('speed').innerHTML = Math.round(loadCount*100 / images.length) +'%';
          if (loadCount==images.length) {
            const pre = document.getElementById('shadow');
            pre.style.visibility='hidden';

          }
        }}
      />;
    })}
    <Box id='shadow'
      style={{
        visibility:'visible',
        background:'white',
        position:'absolute',
        left: 0, top: 0,
        right: 0, bottom: 0,
        display:'flex',
        justifyContent:'center',
        alignItems:'center'
      }}
    >
      <p id='speed'>
        {Math.round(loadCount*100/images.length) +'%'}
      </p>
    </Box>
    <Box
      style={{
        width:'20px', height:'20px',
        position:'absolute',
        bottom:'0px'
      }}
    >
      <img src='https://lite-cdn.yangbentong.com/d6ca9783-c5f9-4dd8-9ca1-b92a95d62e59/6b892de0-b327-4b2d-96fb-88dd607c142a.png'
        style={{width:'20px', height:'20px'}}
      />
    </Box>
  </Box>;
};

export default D3DImageView;